function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_5765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.977 20.1298H7.22567V21.2091H17.6006C18.1645 21.2091 18.1645 22.063 17.6006 22.063H7.22567V23.1585H20.6615V20.1298H12.977ZM20.9354 8.14382C19.7755 8.14382 18.97 7.28999 18.8733 6.29116C16.4407 8.4177 15.5707 10.8342 17.6328 13.3474C20.9515 11.4303 25.8651 13.0896 26.5095 16.3117C28.3299 16.7466 28.0561 19.4854 26.139 19.4854C24.4796 19.4854 24.1252 17.6166 24.979 16.7305C22.337 15.9089 20.7904 16.9883 20.3393 19.2759C20.8387 19.2759 21.5315 19.1632 21.5315 19.7109V23.5773C21.5315 23.819 21.3381 24.0123 21.0965 24.0123H6.80681C6.56516 24.0123 6.37184 23.819 6.37184 23.5773V19.7109C6.37184 19.147 7.08068 19.2759 7.59621 19.2759C7.14512 16.9883 5.61466 15.9089 2.9726 16.7466C3.89088 17.6971 3.32702 19.4854 1.861 19.4854C-0.168878 19.4854 -0.233319 16.6661 1.47436 16.3117C2.07043 13.283 6.37184 11.6558 9.64219 13.0252C9.78718 7.74107 15.1841 3.11746 19.3727 4.68014C20.4199 3.47188 22.5947 3.87464 22.9975 5.59842C23.2875 6.8389 22.3048 8.14382 20.9354 8.14382ZM20.3232 7.14499C21.7892 7.88606 22.9169 5.79174 21.5637 4.98624C20.6293 4.43849 19.4694 5.35677 19.7432 6.37171C19.8399 6.69391 20.0493 6.96778 20.3232 7.14499ZM14.5397 19.2759C14.6363 16.65 15.5868 14.894 16.924 13.8307C14.5558 10.8664 15.5385 7.86995 18.6478 5.35677C14.9102 4.43849 10.351 8.80434 10.496 13.4763C12.0909 14.4751 13.2831 16.3278 13.3959 19.2759H14.5397ZM26.1712 17.1333C26.139 17.1333 26.1229 17.1333 26.0906 17.1333C25.1563 17.1655 25.1079 18.6315 26.139 18.6315C27.1539 18.6315 27.0895 17.1655 26.1712 17.1333ZM2.45707 16.0056C5.90464 14.7973 7.99896 16.3922 8.46615 19.2759H12.542C12.2198 11.978 3.93921 12.0586 2.45707 16.0056ZM17.8261 14.2335C17.81 14.2496 17.7778 14.2657 17.7617 14.2818C16.4729 15.1678 15.5063 16.7627 15.4096 19.2759H19.4694C19.9527 16.3761 22.047 14.7973 25.5268 16.0056C24.5924 13.6696 20.5165 12.4452 17.8261 14.2335ZM1.89322 17.1333C1.87711 17.1333 1.84489 17.1333 1.81267 17.1333C0.878281 17.1816 0.84606 18.6315 1.861 18.6315C2.8115 18.6315 2.76317 17.1655 1.89322 17.1333Z",
    fill: "#D9BEFB",
    style: {
      fill: "#D9BEFB",
      fill: "color(display-p3 0.8510 0.7451 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6006 21.2095C18.1645 21.2095 18.1645 22.0633 17.6006 22.0633H7.22568V23.1588H20.6615V20.1301H12.977H7.22568V21.2095H17.6006ZM26.0906 17.1336C25.1563 17.1659 25.1079 18.6319 26.139 18.6319C27.1539 18.6319 27.0895 17.1659 26.1712 17.1336C26.139 17.1336 26.1229 17.1336 26.0906 17.1336ZM19.4694 19.2763C19.9527 16.3765 22.047 14.7977 25.5268 16.0059C24.5924 13.67 20.5165 12.4456 17.8261 14.2338C17.81 14.2499 17.7778 14.266 17.7617 14.2821C16.4729 15.1682 15.5063 16.7631 15.4096 19.2763H19.4694ZM20.3232 7.14535C21.7892 7.88642 22.9169 5.7921 21.5637 4.9866C20.6293 4.43885 19.4694 5.35713 19.7433 6.37207C19.8399 6.69427 20.0493 6.96814 20.3232 7.14535ZM16.924 13.8311C14.5558 10.8668 15.5385 7.87031 18.6478 5.35713C14.9102 4.43885 10.351 8.8047 10.496 13.4766C12.0909 14.4755 13.2831 16.3281 13.3959 19.2763H14.5397C14.6363 16.6503 15.5868 14.8943 16.924 13.8311Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.542 19.276C12.2198 11.9781 3.93922 12.0587 2.45709 16.0057C5.90465 14.7974 7.99897 16.3923 8.46617 19.276H12.542ZM1.86101 18.6316C2.81151 18.6316 2.76318 17.1656 1.89323 17.1334C1.87712 17.1334 1.8449 17.1334 1.81268 17.1334C0.878292 17.1817 0.846072 18.6316 1.86101 18.6316Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_5765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy);
export default __webpack_public_path__ + "static/media/dummy.6a81e3121de28fc6b59e42b78b5bd30b.svg";
export { ForwardRef as ReactComponent };